import { ContactItemWrapper, SecondaryText } from '../styled';

type ContactItemProps = {
    icon: React.ReactNode;
    title: React.ReactNode;
};

const ContactItem = ({ icon, title }: ContactItemProps) => (
    <ContactItemWrapper>
        {icon}
        <SecondaryText hasMaxWidth>{title}</SecondaryText>
    </ContactItemWrapper>
);

export default ContactItem;
